import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import type {
  Client,
  CreateClientRequest,
} from "@/features/clients/types/clientTypes";

import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { ClientEdit } from "../components/ClientEdit";
import { useCreateClient } from "../hooks/clientQueries";
import { useState } from "react";

export function ClientAddPage() {
  const { goToClients } = useAppNavigation();
  const { businessId } = useCurrentBusiness();
  const createClientMutation = useCreateClient();
  const [contextError, setContextError] = useState<Error | null>(null);

  const handleSubmit = (data: Partial<Client>) => {
    if (!businessId) {
      setContextError(new Error("Select a business before adding a customer."));
      return;
    }
    setContextError(null);

    const createClientRequest: CreateClientRequest = {
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      email: data.email || "",
      businessId,
      phoneNumber: data.phoneNumber || "",
      notes: data.notes || "",
    };

    createClientMutation.mutate(createClientRequest, {
      onSuccess: () => {
        goToClients();
      },
    });
  };

  const emptyClient = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    notes: "",
  };

  return (
    <ClientEdit
      client={emptyClient}
      onSubmit={handleSubmit}
      isSubmitting={createClientMutation.isPending}
      error={contextError || createClientMutation.error}
      title="Add customer"
      submitButtonText="Add customer"
    />
  );
}
